import createApiClient from 'helpers/api/createApiClient';
import config from 'config';

export function settingsApi(user) {
  const api = createApiClient(config.twpSettingsApiUrl(user), {
    Authorization: `Bearer ${user.token}`,
  });

  function fetchSettings() {
    return api.get('/sites/settings');
  }

  function saveSettings(settings) {
    return api.post('/sites/settings', settings);
  }

  return {
    fetchSettings,
    saveSettings,
  };
}

export function siteApi(user, finalizedPayPeriod = false) {
  const url = finalizedPayPeriod
    ? config.twpApiUrlFinalizedPayPeriod
    : config.twpApiUrl;

  const api = createApiClient(url(user), {
    Authorization: `Bearer ${user.token}`,
  });

  function getFinalizationPeriods() {
    return api.get(`/finalizedpayperiods`);
  }

  function getSiteStatusForTWXLeadership() {
    return api.get('/sites/status');
  }

  return {
    getFinalizationPeriods,
    getSiteStatusForTWXLeadership,
  };
}

export function twpApiURL(user) {
  const api = createApiClient(config.twpApiURL, {
    Authorization: `Bearer ${user.token}`,
  });

  async function fetchPayrollActivities(payPeriod, format) {
    const { start, end } = payPeriod ?? {};
    // eslint-disable-next-line max-len
    const url = `/users/payrollactivities?beginDate=${start}&endDate=${end}&format=${format}`;
    const response = await api.get(url);
    return { ...response, config: { url } };
  }

  // Get - /api/users/sites/payperiods/:count
  // default is 2 so we get current and last pay periods
  async function getPayPeriods(count = 2) {
    const url = `/users/sites/payperiods/${count}`;
    const response = await api.get(url);

    return response.data;
  }

  async function getUnfinalizedPayPeriods() {
    const url = '/users/sites/unfinalizedpayperiods';
    const response = await api.get(url);

    return response.data;
  }

  async function getFinalizedPayPeriods() {
    const url = '/users/sites/finalizedpayperiods';
    const response = await api.get(url);

    return response.data;
  }

  async function finalizePayPeriods(date, endpoint) {
    const { beginDate } = date;
    const url = `/users/sites/payperiod/${endpoint}?periodDate=${beginDate}`;
    const response = await api.post(url);

    return response.data;
  }

  async function fetchEmployees({ fetchInactiveEmployees = true }) {
    const onlyActive = !fetchInactiveEmployees;
    const url = `/users/employees?onlyActive=${onlyActive}`;
    return api.get(url);
  }

  async function fetchPunchCategories() {
    const url = '/users/sites/punchcategories';
    const response = await api.get(url);
    return response;
  }

  async function updateEmployeeEnrollment({ policyID, employees }) {
    const url = '/users/wfhaccruals/policy/enrollment';
    const response = await api.put(url, { policyID, employees });
    return response;
  }

  async function deleteEmployeeEnrollment({ policyID, employeeIDs }) {
    const url = '/users/wfhaccruals/policy/enrollment';
    const response = await api.delete(url, { data: { policyID, employeeIDs } });
    return response;
  }

  async function fetchAccrualPolicies() {
    const url = '/users/wfhaccruals/policies';
    const value = await api.get(url);
    return value;
  }

  async function postAccrualPolicies(policies) {
    const url = '/users/wfhaccruals/policies';
    const response = await api.post(url, policies);
    return response.data;
  }

  return {
    deleteEmployeeEnrollment,
    fetchAccrualPolicies,
    fetchEmployees,
    fetchPayrollActivities,
    fetchPunchCategories,
    finalizePayPeriods,
    getUnfinalizedPayPeriods,
    getFinalizedPayPeriods,
    getPayPeriods,
    postAccrualPolicies,
    updateEmployeeEnrollment,
  };
}
